import hljs from 'highlight.js/lib/core';
import defaultExport from './tsql'

hljs.registerLanguage('tsql', defaultExport);

export function highlightSqlCode(code) {
    return hljs.highlight(code, { language: 'tsql' }).value
}